import { React, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ReportMenu from '../common/components/ReportMenu/ReportMenu';

const ReportContainer = () => {
  useEffect(() => {
    const preventScroll = (e) => {
      e.preventDefault();
    };
    document.addEventListener('touchmove', preventScroll, { passive: false });
    return () => {
      document.removeEventListener('touchmove', preventScroll);
    };
  }, []);
  return (

    <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flexShrink: 0 }}>
        <ReportMenu />
      </div>
      <div style={{ flexGrow: 1, overflowY: 'auto' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default ReportContainer;
